import { gql } from 'src/__generated__';

const GET_DATA_EXTRACTION_DEVICES = gql(`#graphql
query DevicesDataExtraction_GetDevices($input: DevicesInput) {
  devices(input: $input) {
    id
    profile {
      id
      name
      operationalState
      irrigation {
        id
      }
    }
  }
}
`);

export default GET_DATA_EXTRACTION_DEVICES;
